export default {"src":"/_next/static/media/global.8a6b5b16.svg","height":51,"width":55,"blurWidth":0,"blurHeight":0};